import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Input, QRCode, Space, Button, Select } from "antd";
import { RestaurantService, TokenService } from "deliziora-client-module/client-web";

export default function NewRestaurantAdmin() {
  const [text, setText] = useState("");
  const [restaurantSelected, setRestaurantSelected] = useState(null);
  const [restaurantNameSelected, setRestaurantNameSelected] = useState(null);

  const downloadQRCode = () => {
    const canvas = document.getElementById("myqrcode")?.querySelector("canvas");
    if (canvas) {
      const url = canvas.toDataURL();
      const a = document.createElement("a");
      a.download = "Invitation.png";
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const getAllRestaurants = () => {
    RestaurantService.returnAllRestaurantsSlim()
      .then((res) => {
        const options = res.data.map((restaurant) => ({
          value: restaurant._id.$oid,
          label: restaurant.name + " - " + restaurant.address,
        }));
        setRestaurantSelected(options);
      }).catch((error) => {
        console.error("Error fetching restaurants:", error);
        setRestaurantSelected([]);
      });
  }

  useEffect(() => {
    generateNewId();
    getAllRestaurants();
  }, []);

  const generateNewId = () => {
    const restaurantId = restaurantNameSelected || null;
    TokenService.createToken().then((res) => {
      if (restaurantId != undefined) {
        setText(window.document.location.origin + "/create-restaurant/" + res.data + "?restaurantId=" + restaurantId);
      }
      else {
        setText(window.document.location.origin + "/create-restaurant/" + res.data);
      }
    })

  };
  return (
    <Space
      direction="vertical"
      align="center"
      id="myqrcode"
      style={{
        width: "100vw",
        height: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <QRCode value={text || "-"} />

      <Select
        showSearch
        style={{
          width: "50vw",
        }}
        placeholder="Selecione um Restaurante"
        filterOption={(input, option) => {
          var _a;
          return (
            (_a = option === null || option === void 0 ? void 0 : option.label) !== null &&
              _a !== void 0
              ? _a
              : ''
          )
            .toLowerCase()
            .includes(input.toLowerCase());
        }}
        options={restaurantSelected}
        value={restaurantNameSelected}
        onChange={(value) => {
          setRestaurantNameSelected(value);
          const selectedRestaurant = restaurantSelected.find((restaurant) => restaurant.value === value);
          console.log("Selected Restaurant:", selectedRestaurant);
          if (selectedRestaurant) {
            TokenService.createToken().then((res) => {
              setText(window.document.location.origin + "/create-restaurant/" + res.data + "?restaurantId=" + value);
            });
          } else {
            setText("");
          }
        }}
      />

      <Input
        placeholder="-"
        value={text}
        onChange={(e) => setText(e.target.value)}
        styles={{ input: { textAlign: "center", width: "50vw" } }}
      />

      <Button type="primary" onClick={downloadQRCode}>
        Download
      </Button>
      <Button type="primary" onClick={generateNewId}>
        Gerar Novo Codigo
      </Button>
    </Space>
  );
}
